/** 游客免费次数 service。 */
export interface GuestFreeUsageService {
    /**
     * 查询当前用户是否可以使用指定任务类型的一次游客免费次数。
     * @param taskType AI 任务类型。
     */
    canUseOnce(taskType: string): Promise<boolean>;
}

/** 游客免费次数 service 的容器标识。 */
export const GuestFreeUsageService = Symbol('GuestFreeUsageService');
